module.exports = __webpack_public_path__ + "img/animol.ef4f29e6.png";